import React from 'react'
import styled from 'styled-components'
import { Card, Heading1 } from 'adl'

import ListItem from 'components/ListItem'
import StandardLayout from 'components/layouts/Standard'
import MarketingTile from 'components/MarketingTile'

const SectionTitle = styled.div`
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
`

const ListItemMain = styled.div`
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
`

const ListItemSub = styled.div`
  font-size: 1rem;
  color: ${props => props.theme.colors.gray500};
`

const IconRight = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  padding-right: 0.5rem;
`

export default () => (
  <StandardLayout>
    <Heading1>Move Money</Heading1>
    <div style={{ maxWidth: 768 }}>

      <MarketingTile style={{ marginBottom: '2rem' }} />

      <SectionTitle>Transfers</SectionTitle>

      <Card elevation={2}>
        <ListItem>
          <ListItemMain>Between My Accounts</ListItemMain>
          <ListItemSub>My checking and savings accounts</ListItemSub>
          <IconRight>
            <i className="icon-chevron-right" />
          </IconRight>
        </ListItem>
      </Card>

      <SectionTitle>Pay Bills</SectionTitle>
      <Card elevation={2}>
        <ListItem>
          <ListItemMain>Pay My Loan or Credit Card</ListItemMain>
          <ListItemSub>Loans and credit cards at this credit union</ListItemSub>
          <IconRight>
            <i className="icon-chevron-right" />
          </IconRight>
        </ListItem>
        <ListItem>
          <ListItemMain>Pay Other Bills</ListItemMain>
          <ListItemSub>Accounts with other companies</ListItemSub>
          <IconRight>
            <i className="icon-chevron-right" />
          </IconRight>
        </ListItem>
      </Card>

      <SectionTitle>Send or Request Money</SectionTitle>

      <Card elevation={2}>
        <ListItem>
          <ListItemMain>Send To Another Member</ListItemMain>
          <ListItemSub>
            Send to another account holder at this credit union
          </ListItemSub>
          <IconRight>
            <i className="icon-chevron-right" />
          </IconRight>
        </ListItem>
        <ListItem>
          <ListItemMain>To A Person Through Zelle</ListItemMain>
          <ListItemSub>Send or request by phone number or email</ListItemSub>
          <IconRight>
            <i className="icon-chevron-right" />
          </IconRight>
        </ListItem>
      </Card>

      <SectionTitle>Manage</SectionTitle>
      <Card elevation={2}>
        <ListItem>
          <ListItemMain>Manage My External Accounts</ListItemMain>
          <ListItemSub>
            Add and verify deposit accounts with other banks
          </ListItemSub>
          <IconRight>
            <i className="icon-chevron-right" />
          </IconRight>
        </ListItem>
      </Card>
    </div>
  </StandardLayout>
)
